export const zahaIRL = [
    {
      src: 'https://i.imgur.com/eyz74dj.png',
      width: 1,
        height: 1,
    },
    {
      src: 'https://i.imgur.com/lhAf3Xq.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/UW96C3Q.jpeg',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/iBBfeQs.jpeg',
      width: 1,
        height: 1,
      },
  
  ]
  
  export const zaha = [
    {
      src: 'https://i.imgur.com/8Sx5seJ.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/FHLVQO9.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/3iQlrrH.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/rRA0SaJ.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/koMwuUi.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/j6e7gWu.jpg',
      width: 1,
      height: 1,
    },
  ];
  
  export const architecture = [
    {
      src: 'https://i.imgur.com/X8EkFwU.jpg',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/lHhriKR.png',
      width: 1,
      height: 1,
    },
  ];
  
  export const architecture2 = [
    {
      src: 'https://i.imgur.com/REfZIK5.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/ckVxv27.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/Zoj4xP8.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/eP6WvJr.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/EdduM2g.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/iN0iysy.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/eGyBofE.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/erO0QST.png',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/y2f7Z1E.png',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/gkw1Cwe.png',
      width: 1,
      height: 1,
    },
  
    {
      src:'https://i.imgur.com/MIUOSf2.png',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/ZeakYgF.png',
      width: 1,
      height: 1,
    }
  ];
  
  export const objects = [
  
    {
      src: 'https://i.imgur.com/pNwuCMO.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/G13TIvf.png',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/TVcIMwN.png',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/7fMnuyw.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/dMTB3Ty.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/QXugsWX.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/7d8feso.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/e2GavmR.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/kOPLaGx.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/1aO4vvd.jpg',
      width: 1,
      height: 1,
    },
    
  ]; 
  export const misc= [
    {
      src:'https://i.imgur.com/OGkbSlJ.jpg',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/C5rieRz.jpg',
      width: 1,
      height: 1,
    },
    { 
      src:'https://i.imgur.com/KGkx22L.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/S6wwAvI.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/FHfst46.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/A3l3a3z.png',
      width: 1,
      height: 1,
    },
    {
      src: 'https://i.imgur.com/CG3ueAU.png',
      width: 1,
      height: 1,
    },
    {
      src:'https://i.imgur.com/Xwjj8RE.png',
      width: 1,
      height: 1,
    }
  
  ]